export default __webpack_public_path__ + "static/media/main.b867f56e.jpg";